const $ = window.jQuery;

var $siteHeaderMain = $('.site-header, .site-main');

$('.open-site-header').on('click', function () {
  $siteHeaderMain.toggleClass('open');
});

$('.close-site-header').on('click', function () {
  $siteHeaderMain.removeClass('open');
});
